/**IMPORTANT LIBRARY IMPORTS */
import React from "react";


/**COMPONENTS IMPORT */
import PageHero from "../Components/PageHero";



const Contact=()=>{
    return(
        <>
         {/**HERO SECTION */}
        <PageHero heading={"Get in Touch"}/>
        </>
    )
}

export default Contact;